export const ACTIVE_CHALLENGE_STORAGE_KEY = 'activeChallengeId'
export const PREFERS_WEB_STORAGE_KEY = 'prefersWeb'
